import React, { useEffect, useState } from 'react';
import './Exhibitions.css';

function Exhibitions() {
  const [exhibitions, setExhibitions] = useState([]);

  useEffect(() => {
    // Backend se data fetch karenge
    fetch("https://himchatterjee.in/backend/getExhibitions.php")
      .then(res => res.json())
      .then(data => setExhibitions(data))
      .catch(err => console.error("Error fetching exhibitions:", err));
  }, []);

  return (
    <div className="exhibitions-container">
      <h1>Exhibitions</h1>
      <div className="exhibition-list">
        {exhibitions.map((exhibition, index) => (
          <div key={exhibition.id} className="exhibition-card">
            <div className="exhibition-photos">
              {/* Display first two photos, fallback to cover */}
              <img
                src={`https://himchatterjee.in/backend/uploads/exhibitions/${exhibition.cover}`}
                alt={exhibition.name}
                className="exhibition-photo fade-in"
              />
              {exhibition.cover2 && (
                <img
                  src={`https://himchatterjee.in/backend/uploads/exhibitions/${exhibition.cover2}`}
                  alt={exhibition.name + " 2"}
                  className="exhibition-photo fade-in delay"
                />
              )}
            </div>
            <div className="exhibition-info">
              <h2>{exhibition.name}</h2>
              <p className="description">{exhibition.description}</p>
              <p className="venue-date">{exhibition.venue} | {new Date(exhibition.date).toLocaleDateString()}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Exhibitions;
